(function () {
  'use strict';

  // Wait for Swiper to load
  function waitForSwiper(callback, attempts = 0) {
    if (window.Swiper && typeof window.Swiper === 'function') {
      callback();
      return;
    }

    if (attempts < 20) {
      setTimeout(() => waitForSwiper(callback, attempts + 1), 100);
    } else {
    }
  }

  // Note: Text localization is now handled globally in theme.liquid

  // Lazy initialize carousels with Intersection Observer
  function initializeCarousels() {
    const carousels = document.querySelectorAll('.card-media-carousel');

    // Use Intersection Observer for lazy loading
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            initializeCarousel(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '100px', // Start loading 100px before entering viewport
        threshold: 0.1,
      },
    );

    carousels.forEach((carousel) => {
      if (!carousel.dataset.initialized) {
        observer.observe(carousel);
      }
    });
  }

  // Initialize individual carousel
  function initializeCarousel(carousel) {
    if (carousel.dataset.initialized) return;
    const productId = carousel.dataset.productId;
    const sliderId = `CardSlider-${productId}`;
    const slider = carousel.querySelector(`#${sliderId}`);

    if (slider && !slider.swiper) {
      // Initialize Swiper
      const swiper = new Swiper(carousel.querySelector('.card-slider'), {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: false,
        on: {
          init: function () {
            // Hide navigation if only one slide
            const slideCount = this.slides.length;
            if (slideCount <= 1) {
              const buttons = carousel.querySelector('.card-slider-buttons');
              if (buttons) buttons.style.display = 'none';
            }
          },
        },
      });

      // Set up custom navigation with debugging
      const prevButton = carousel.querySelector('.card-slider-button--prev');
      const nextButton = carousel.querySelector('.card-slider-button--next');

      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          swiper.slidePrev();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          swiper.slideNext();
        });
      }

      // Mark as initialized
      carousel.dataset.initialized = 'true';
    }
  }

  // Initialize carousels on DOM changes (e.g., GrapheneHC loading, infinite scroll)
  const observer = new MutationObserver((mutations) => {
    let shouldReinit = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.querySelector &&
            node.querySelector('.card-media-carousel')
          ) {
            shouldReinit = true;
          }
        });
      }
    }

    if (shouldReinit) {
      setTimeout(initializeCarousels, 100);
    }
  });

  // Start observing for GrapheneHC content
  function startObserving() {
    // First try to observe the product grid (after GrapheneHC loads)
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      observer.observe(productGrid, {
        childList: true,
        subtree: true,
      });
      return true;
    }

    // Fallback: observe the Results container (always exists)
    const resultsContainer = document.getElementById('Results');
    if (resultsContainer) {
      observer.observe(resultsContainer, {
        childList: true,
        subtree: true,
      });
      return true;
    }

    return false;
  }

  // Start observing immediately
  if (!startObserving()) {
    // If neither container exists, try again after a short delay
    setTimeout(startObserving, 100);
  }

  // Also initialize on DOMContentLoaded as fallback
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForSwiper(initializeCarousels);
    });
  } else {
    waitForSwiper(initializeCarousels);
  }

  // Additional initialization on window load
  window.addEventListener('load', () => {
    setTimeout(() => {
      waitForSwiper(initializeCarousels);
    }, 500);
  });
})();
